<h2 mat-dialog-title>{{ data.header }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close cdkFocusInitial class="btn">{{ data.cancelLabel || 'Cancel' }}</button>
  <button [mat-dialog-close]="true" class="btn btn-primary">{{ data.confirmLabel }}</button>
</mat-dialog-actions>
